import { z } from 'zod';
export const StudyPageCopyPatchSchema = z.record(z.string().min(1).max(100), z.string().max(2000).nullable());
export const StudyPageLocaleSchema = z.object({
    participantHeading: z.string().nullable(),
    participantTitle: z.string().nullable(),
    participantDescription: z.string().nullable(),
    participantEmailHeading: z.string().max(100).nullable(),
    participantEmailBody: z.string().max(500).nullable(),
    participantCopy: z.record(z.string(), z.string()),
});
export const StudyPageContentSnapshotSchema = z.object({
    defaultLocale: z.string(),
    locales: z.record(z.string(), StudyPageLocaleSchema),
});
export const StudyPageContentSchema = StudyPageContentSnapshotSchema.extend({
    revision: z.string(),
    productLine: z.enum(['insights', 'customer_success']),
});
export const StudyPageContentPatchSchema = z
    .object({
    expectedRevision: z.string().min(1),
    locales: z.record(z.string().min(2).max(35), StudyPageLocaleSchema.omit({ participantCopy: true })
        .partial()
        .extend({
        participantCopy: StudyPageCopyPatchSchema.optional(),
    })
        .strict()),
})
    .strict();
//# sourceMappingURL=StudyPageContent.js.map